import {createAction} from '@reduxjs/toolkit';

export const httpMonitorsStale = createAction('monitoring/httpMonitorsStale');

type Dispatch = (_action: ReturnType<typeof httpMonitorsStale>) => unknown;

export const invalidateHttpMonitors = (dispatch: Dispatch) => dispatch(httpMonitorsStale());
